import { FC, PropsWithChildren } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { Router } from "./routing/Router";
import "./styles/_global.scss";
import UserInfoProvider from "./utils/customHooks/useInfo";
import ToastProvider, { useToast } from "./utils/customHooks/useToast";

const queryClient = (
  showToast: Pick<ReturnType<typeof useToast>, "showToast">["showToast"]
) =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        refetchOnReconnect: true,
      },
      mutations: {
        onError(error: any) {
          if (error.data && typeof error.data === "string") {
            showToast(error.data, "error");
          }
        },
      },
    },
  });

const AppWrapper: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ToastProvider>
      <App />
    </ToastProvider>
  );
};

function App() {
  const { showToast } = useToast();

  return (
    <QueryClientProvider client={queryClient(showToast)}>
      <UserInfoProvider>
        <Router />
      </UserInfoProvider>
    </QueryClientProvider>
  );
}

export default AppWrapper;
